import React from "react";
import { BrowserRouter as Router, Route, Routes, useLocation } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { CartProvider } from "./context/CartContext";
import { useJsApiLoader } from '@react-google-maps/api'; // Import JsApiLoader
import ProtectedRoute from "./components/ProtectedRoute"; 
import CustomNavbar from "./components/CustomNavbar";
import Cart from "./components/Cart";
import AddressPage from "./pages/AddressPage";
import DeliveryPickupPage from "./pages/DeliveryPickupPage";
import CheckoutPage from "./pages/CheckoutPage";
import Login from "./components/Login";
import CourierLogin from "./pages/CourierLogin"; // Import CourierLogin
import OrderConfirmationPage from "./pages/OrderConfirmationPage";
import VendorMenuPage from "./pages/VendorMenuPage";
import TestDashboard from "./pages/TestDashboard";
import RegistrationPage from "./pages/RegistrationPage";
import ResetPasswordRequest from './components/ResetPasswordRequest';
import ResetPassword from './components/ResetPassword';
import ContactPage from "./pages/ContactPage";
import SalesRepPage from "./pages/SalesRepPage";
// import OrdersPage from "./pages/OrdersPage";
import AddStrainForm from "./pages/AddStrainForm";
import IntegrationsPage from "./pages/IntegrationsPage";
import SubscriptionPage from "./pages/SubscriptionPage";
import './styles.css';
import TermsAndConditions from "./pages/TermsAndConditions";
import WeedHurryCourier from "./pages/WeedHurryCourier";
import CourierRequestPage from "./pages/CourierRequestPage";
import CourierOrdersPage from "./pages/CourierOrdersPage";
import CourierDashboard from "./pages/CourierDashboard";
import ProtectedCourierRoute from "./components/ProtectedCourierRoute";

// Load Google Maps API once at the app level to avoid multiple loads
function AppWithGoogleMaps() {
  // Load Google Maps API
  const { isLoaded, loadError } = useJsApiLoader({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
    libraries: ['places'],
  });

  if (loadError) {
    return <div>Error loading Google Maps API</div>;
  }

  if (!isLoaded) {
    return <div>Loading Google Maps API...</div>;
  }

  return <AppWrapper />;
}

function AppWrapper() {
    const location = useLocation();
    
    const hideNavbarRoutes = ["/register", "/checkout", "/", "/vendor-dashboard", "/nearby", "/courier", "/courier-request", "/courier-login", "/courier-dashboard", "/courier-orders"];
    const shouldShowNavbar = !hideNavbarRoutes.includes(location.pathname);

    return (
        <>
            {shouldShowNavbar && <CustomNavbar />}
            <Cart />
            <Routes>
                {/* Public Routes */}
                <Route path="/" element={<AddressPage />} />
                <Route path="/nearby" element={<DeliveryPickupPage />} />
                <Route path="/checkout" element={<CheckoutPage />} />
                <Route path="/register" element={<RegistrationPage />} />
                <Route path="/login" element={<Login />} />
                <Route path="/contact" element={<ContactPage />} />
                <Route path="/sales" element={<SalesRepPage />} />
                <Route path="/courier" element={<WeedHurryCourier />} />
                <Route path="/courier-request" element={<CourierRequestPage />} />
                <Route path="/courier-orders" element={<CourierOrdersPage />} />
                <Route path="/courier-login" element={<CourierLogin />} />
                <Route path="/add-strain" element={<AddStrainForm />} />
                <Route path="/terms" element={<TermsAndConditions />} />
                <Route path="/reset-password-request" element={<ResetPasswordRequest />} />
                <Route path="/reset-password/:token" element={<ResetPassword />} />
                <Route path="/order-confirmation/:orderId" element={<OrderConfirmationPage />} />
                <Route path="/vendor/:vendorId/menu" element={<VendorMenuPage />} />

                {/* Protected Routes */}
                <Route
                    path="/vendor-dashboard"
                    element={
                        <ProtectedRoute>
                            <TestDashboard />
                        </ProtectedRoute>
                    }
                />
                <Route 
                    path="/vendor/integrations" 
                    element={
                        <ProtectedRoute>
                            <IntegrationsPage />
                        </ProtectedRoute>
                    } 
                />
                {/* Subscription Page Route */}
                <Route 
                    path="/vendor/subscription" 
                    element={
                        <ProtectedRoute>
                            <SubscriptionPage />
                        </ProtectedRoute>
                    } 
                />

<Route
  path="/courier-dashboard"
  element={
    <ProtectedCourierRoute>
      <CourierDashboard />
    </ProtectedCourierRoute>
  }
/>
                
            </Routes>
        </>
    );
}

function App() {
    return (
        <AuthProvider>
            <CartProvider>
                <Router>
                    <AppWithGoogleMaps />
                </Router>
            </CartProvider>
        </AuthProvider>
    );
}

export default App;